import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/home/home-hello-line.svg'
import _imports_1 from '@/assets/home/home-microsoft-icons-02.png'
import _imports_2 from '@/assets/home/home-about-us-bg.svg'
import _imports_3 from '@/assets/home/home-about-us-dots.svg'
import _imports_4 from '@/assets/home/about-us-image.jpg'
import _imports_5 from '@/assets/home/home-development-bg.svg'
import _imports_6 from '@/assets/home/home-development-dots.svg'
import _imports_7 from '@/assets/home/development-image.jpg'
import _imports_8 from '@/assets/home/home-hosting-img-2.png'
import _imports_9 from '@/assets/home/home-hosting-bg.svg'
import _imports_10 from '@/assets/home/hosting-image.jpg'
import _imports_11 from '@/assets/home/testimony-icon.png'


const _hoisted_1 = { class: "section-container bg-white" }
const _hoisted_2 = { class: "home-banner px-0 px-lg-5" }
const _hoisted_3 = {
  class: "container py-4 px-5 px-lg-0",
  style: {"max-width":"1200px"}
}
const _hoisted_4 = { class: "row py-sm-3 py-md-5" }
const _hoisted_5 = {
  id: "AboutUs",
  class: "about-us"
}
const _hoisted_6 = { class: "container py-1 pb-md-5" }
const _hoisted_7 = { class: "row py-lg-5" }
const _hoisted_8 = {
  class: "col-12 col-lg-6 py-4 py-lg-5 px-5 wow animate__fadeIn",
  "data-wow-delay": "0.5s"
}
const _hoisted_9 = {
  class: "col-12 col-lg-6 category-images wow animate__fadeIn",
  "data-wow-delay": "0.75s"
}
const _hoisted_10 = {
  key: 0,
  class: "section-container case-studies pb-5"
}
const _hoisted_11 = { id: "CaseStudies" }
const _hoisted_12 = { class: "carousel-navigation d-flex justify-content-center mb-4" }
const _hoisted_13 = ["data-wow-delay"]
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "shadow card-body" }
const _hoisted_16 = {
  id: "Development",
  class: "development"
}
const _hoisted_17 = { class: "container py-1 pb-md-5" }
const _hoisted_18 = { class: "row py-lg-5" }
const _hoisted_19 = {
  class: "col-12 col-lg-6 py-4 py-lg-5 px-5 order-lg-1 wow animate__fadeIn",
  "data-wow-delay": "0.5s"
}
const _hoisted_20 = {
  class: "col-12 col-lg-6 category-images order-lg-0 wow animate__fadeIn",
  "data-wow-delay": "0.75s"
}
const _hoisted_21 = {
  id: "Hosting",
  class: "hosting"
}
const _hoisted_22 = { class: "container py-1 pb-md-5" }
const _hoisted_23 = { class: "row py-lg-5" }
const _hoisted_24 = {
  class: "col-12 col-lg-6 py-4 py-lg-5 px-5 wow animate__fadeIn",
  "data-wow-delay": "0.5s"
}
const _hoisted_25 = {
  class: "col-12 col-lg-6 category-images wow animate__fadeIn",
  "data-wow-delay": "0.75s"
}
const _hoisted_26 = { class: "container text-center" }
const _hoisted_27 = { class: "row my-5" }
const _hoisted_28 = ["data-wow-delay"]
const _hoisted_29 = ["href"]
const _hoisted_30 = { class: "client-item" }
const _hoisted_31 = ["src", "alt"]
const _hoisted_32 = {
  key: 0,
  class: "section-container bg-white wow animate__fadeIn",
  "data-wow-delay": "1s"
}
const _hoisted_33 = { class: "testimonials py-5" }
const _hoisted_34 = { class: "container-fluid container-lg text-center py-3" }
const _hoisted_35 = { class: "h3 mb-4" }
const _hoisted_36 = { class: "row justify-content-center" }
const _hoisted_37 = { class: "col-lg-9" }
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = { class: "h5 d-block mb-3" }
const _hoisted_40 = { class: "section-container subsidiaries" }
const _hoisted_41 = { class: "container text-center py-1 pb-md-5" }
const _hoisted_42 = { class: "py-5" }
const _hoisted_43 = ["data-wow-delay"]
const _hoisted_44 = { class: "card-body pt-4" }
const _hoisted_45 = ["src", "alt"]
const _hoisted_46 = ["innerHTML"]
const _hoisted_47 = { class: "text-start px-3 pb-2 pb-md-5 pb-lg-0" }
const _hoisted_48 = ["src"]
const _hoisted_49 = { class: "section-container bg-white" }
const _hoisted_50 = {
  class: "row",
  id: "ContactUs"
}
const _hoisted_51 = { class: "col-lg-6 order-lg-1 px-5 pb-5 pt-sm-5" }

import { ref, Ref, onMounted } from "vue"
  import LottieObject from "@/components/general/LottieObject.vue"
  import ContentBlock from "@/components/general/ContentBlock.vue"
  import ContactForm from "@/components/general/ContactForm.vue"
  import { CmsBaseUrl, scrollTop } from "@/utils/functions"
  import { getClientLogos, getClientQuotes, getClientSlug, getSubsidiarySlug, getCaseStudyThumbnail, getSubsidiaries } from "@/utils/graphql"
  import { useApolloClient } from '@vue/apollo-composable'
  import 'vue3-carousel/dist/carousel.css'
  import { Carousel, Slide, Navigation } from 'vue3-carousel'
  import router from "@/router"
  import 'animate.css'
  import 'wow.js'
  import 'wowjs'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

  var clientList: Ref<any | undefined> = ref(undefined)
  var clientQuotes: Ref<any | undefined> = ref(undefined)
  var caseStudyThumbnail: Ref<any | undefined> = ref(undefined)
  var subsidiaries: Ref<any | undefined> = ref(undefined)
  var CaseStudies: Ref<any> = ref(null)
  var breakpointCaseStudy: Ref<any | undefined> = ref({
    0: {
      itemsToShow: 1.1
    },
    460: {
      itemsToShow: 1.75
    },
    768: {
      itemsToShow: 2
    },
    992: {
      itemsToShow: 3.5
    },
    1200: {
      itemsToShow: 4
    },
    1400: {
      itemsToShow: 5
    }
  })
  var breakpointSubsidiary: Ref<any | undefined> = ref({
    0: {
      itemsToShow: 1
    },
    768: {
      itemsToShow: 2
    },
    1200: {
      itemsToShow: 3
    }
  })

  function caseStudyPrev() {
    CaseStudies.value.prev()
  }

  function caseStudyNext() {
    CaseStudies.value.next()
  }
  
  onMounted(async () => {
    const { resolveClient } = useApolloClient()
    const ApolloClient = resolveClient()
    
    await getClientLogos(ApolloClient).then(res => {
      clientList.value = res as any
    });
    await getClientQuotes(ApolloClient).then(res => {
      clientQuotes.value = res as any
    });
    await getCaseStudyThumbnail(ApolloClient).then(res => {
      caseStudyThumbnail.value = res as any
    });
    await getSubsidiaries(ApolloClient).then(res => {
      subsidiaries.value = res as any
    });

    setTimeout(() => {
      if (router.currentRoute.value.hash.includes("ContactUs")) {
        scrollTop("#ContactUs")
      }
    }, 200)
  })

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(LottieObject, {
        class: "col-12 col-lg-5 home-left-lottie",
        jsonFile: "home-left-intro.json",
        loop: false
      }),
      _createVNode(LottieObject, {
        class: "col-12 col-lg-5 home-right-lottie",
        jsonFile: "home-right-intro_1.json",
        loop: false
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(LottieObject, {
              class: "col-12 col-md-7 pt-2 pt-md-5",
              jsonFile: "home-hello.json",
              loop: false
            }),
            _cache[2] || (_cache[2] = _createElementVNode("img", {
              class: "col-5 d-none d-lg-block wow animate__fadeIn",
              "data-wow-delay": "0.5s",
              "data-wow-duration": "1s",
              src: _imports_0,
              alt: "Hello!",
              style: {"height":"300px","margin-left":"-12%"}
            }, null, -1))
          ]),
          _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"row py-sm-3 py-md-5\" data-v-20670d92><h1 class=\"col-12 col-lg-6 pt-4 pt-lg-1 wow animate__fadeInUp\" data-wow-delay=\"0.5s\" data-v-20670d92>We are Nologo Studios.<br data-v-20670d92>Your Technology Partners.</h1><br class=\"d-block d-md-none\" data-v-20670d92><br class=\"d-block d-md-none\" data-v-20670d92><img class=\"col-12 col-lg-5 pt-4 pt-lg-1 wow animate__fadeInUp\" data-wow-delay=\"1s\" src=\"" + _imports_1 + "\" alt=\"Certified as Microsoft Gold Partner and Google Partner\" style=\"max-width:fit-content;height:10%;\" data-v-20670d92></div><div class=\"row pt-5\" data-v-20670d92><p class=\"wow animate__fadeIn\" data-wow-delay=\"1s\" data-v-20670d92><span class=\"slogan-text text-primary\" data-v-20670d92>nothing. </span><br class=\"d-block d-lg-none fw-500 lh-1\" data-v-20670d92> don&#39;t believe in digital for the sake of digital.</p><p class=\"wow animate__fadeIn\" data-wow-delay=\"1.25s\" data-v-20670d92><span class=\"slogan-text text-secondary\" data-v-20670d92>but. </span><br class=\"d-block d-lg-none fw-500\" data-v-20670d92> developing and implementing clear strategies for how digital can grow your business.</p><p class=\"wow animate__fadeIn\" data-wow-delay=\"1.5s\" data-v-20670d92><span class=\"slogan-text text-tertiary\" data-v-20670d92>excellence. </span><br class=\"d-block d-lg-none fw-500\" data-v-20670d92> brilliant custom digital solutions.</p></div><br data-v-20670d92>", 3)),
          _createVNode(_component_router_link, {
            to: "#AboutUs",
            class: "",
            style: {"width":"220px","display":"contents"}
          }, {
            default: _withCtx(() => [
              _createVNode(LottieObject, {
                class: "col-12 col-lg-5 py-0 py-lg-5",
                jsonFile: "home-arrow.json",
                style: {"width":"220px","margin-left":"auto","margin-right":"auto","display":"block"}
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(ContentBlock, {
                alias: "home-about-us",
                subtitleFirst: true
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(LottieObject, {
                class: "home-aboutus-animation d-none d-lg-block",
                jsonFile: "about-us.json"
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createElementVNode("img", {
                    class: "img1",
                    src: _imports_2,
                    alt: "",
                    style: {"top":"0"}
                  }, null, -1),
                  _createElementVNode("img", {
                    class: "img2",
                    src: _imports_3,
                    alt: "",
                    style: {"top":"0"}
                  }, null, -1),
                  _createElementVNode("img", {
                    class: "img3",
                    src: _imports_4,
                    alt: ""
                  }, null, -1)
                ])),
                _: 1
              }),
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "d-lg-none overflow-hidden" }, [
                _createElementVNode("img", {
                  class: "img-fluid img3",
                  src: _imports_4,
                  alt: ""
                })
              ], -1))
            ])
          ])
        ])
      ]),
      (_unref(caseStudyThumbnail) && _unref(caseStudyThumbnail).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "case-studies-text" }, [
              _createElementVNode("h2", { class: "text-white text-center" }, [
                _createElementVNode("small", { class: "text-uppercase d-block" }, "Nologo Studios"),
                _createTextVNode(" Case Studies ")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (caseStudyPrev())),
                  class: "carousel-control-prev position-relative",
                  type: "button"
                }, _cache[6] || (_cache[6] = [
                  _createElementVNode("span", {
                    class: "carousel-control-prev-icon",
                    "aria-hidden": "true"
                  }, null, -1),
                  _createElementVNode("span", { class: "visually-hidden" }, "Previous", -1)
                ])),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (caseStudyNext())),
                  class: "carousel-control-next position-relative",
                  type: "button"
                }, _cache[7] || (_cache[7] = [
                  _createElementVNode("span", {
                    class: "carousel-control-next-icon",
                    "aria-hidden": "true"
                  }, null, -1),
                  _createElementVNode("span", { class: "visually-hidden" }, "Next", -1)
                ]))
              ]),
              _createVNode(_unref(Carousel), {
                ref_key: "CaseStudies",
                ref: CaseStudies,
                breakpoints: _unref(breakpointCaseStudy),
                autoplay: 5000,
                "wrap-around": true
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(caseStudyThumbnail), (caseStudy, index) => {
                    return (_openBlock(), _createBlock(_unref(Slide), { key: caseStudy }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "card overflow-hidden wow animate__fadeIn",
                          "data-wow-delay": `0.${5+index}s`
                        }, [
                          _createElementVNode("img", {
                            src: _unref(CmsBaseUrl)() + caseStudy.logoThumbnail.urls[0]
                          }, null, 8, _hoisted_14),
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_router_link, {
                              class: "btn btn-outline-dark text-uppercase rounded-0 py-2 px-4 px-sm-5",
                              to: { name: 'case-study', params: { alias: _unref(getClientSlug)(caseStudy.alias.alias) } }
                            }, {
                              default: _withCtx(() => _cache[8] || (_cache[8] = [
                                _createTextVNode(" View Case Study ")
                              ])),
                              _: 2
                            }, 1032, ["to"])
                          ])
                        ], 8, _hoisted_13)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["breakpoints"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createVNode(ContentBlock, {
                alias: "home-development",
                subtitleFirst: true
              })
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(LottieObject, {
                class: "home-development-animation d-none d-lg-block",
                jsonFile: "development.json"
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createElementVNode("img", {
                    class: "img1",
                    src: _imports_5,
                    alt: "",
                    style: {"top":"0","left":"20% !important"}
                  }, null, -1),
                  _createElementVNode("img", {
                    class: "img2",
                    src: _imports_6,
                    alt: "",
                    style: {"top":"-51%","right":"34% !important"}
                  }, null, -1),
                  _createElementVNode("img", {
                    class: "img3",
                    src: _imports_7,
                    alt: ""
                  }, null, -1)
                ])),
                _: 1
              }),
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "d-lg-none overflow-hidden" }, [
                _createElementVNode("img", {
                  class: "img-fluid img3",
                  src: _imports_7,
                  alt: ""
                }),
                _createElementVNode("hr", { class: "m-0" })
              ], -1))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(ContentBlock, {
                alias: "home-hosting",
                subtitleFirst: true
              })
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(LottieObject, {
                class: "home-hosting-animation d-none d-lg-block",
                jsonFile: "hosting.json"
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createElementVNode("img", {
                    class: "img5",
                    src: _imports_8,
                    alt: ""
                  }, null, -1),
                  _createElementVNode("img", {
                    class: "img2",
                    src: _imports_9,
                    alt: "",
                    style: {"top":"0","width":"60% !important"}
                  }, null, -1),
                  _createElementVNode("img", {
                    class: "img2",
                    src: _imports_6,
                    alt: "",
                    style: {"top":"0","right":"10% !important"}
                  }, null, -1),
                  _createElementVNode("img", {
                    class: "img4",
                    src: _imports_10,
                    alt: ""
                  }, null, -1)
                ])),
                _: 1
              }),
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "d-lg-none overflow-hidden" }, [
                _createElementVNode("img", {
                  class: "img-fluid img4",
                  src: _imports_10,
                  alt: ""
                })
              ], -1))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _cache[15] || (_cache[15] = _createElementVNode("hr", { class: "mt-3 my-5" }, null, -1)),
        _cache[16] || (_cache[16] = _createElementVNode("h2", null, [
          _createElementVNode("small", { class: "d-block" }, "These are"),
          _createTextVNode(" Our Clients ")
        ], -1)),
        _createElementVNode("div", _hoisted_27, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(clientList), (client, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-12 col-sm-6 col-lg-3 wow animate__fadeIn",
              "data-wow-delay": `0.${5+index}s`
            }, [
              _createElementVNode("a", {
                href: client.siteLink,
                target: "_blank"
              }, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("img", {
                    class: "img-fluid px-2",
                    src: _unref(CmsBaseUrl)() + client.logo.urls[0],
                    alt: client.displayText + ' logo'
                  }, null, 8, _hoisted_31)
                ])
              ], 8, _hoisted_29)
            ], 8, _hoisted_28))
          }), 256))
        ]),
        _createVNode(_component_router_link, {
          class: "btn btn-outline-dark text-uppercase rounded-0 py-2 px-4 px-sm-5",
          to: "/clients"
        }, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [
            _createTextVNode("Read More")
          ])),
          _: 1
        }),
        _cache[17] || (_cache[17] = _createElementVNode("hr", { class: "my-5" }, null, -1))
      ])
    ]),
    (_unref(clientQuotes) && _unref(clientQuotes).additionalContent.contentItems.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("h2", _hoisted_35, _toDisplayString(_unref(clientQuotes).contentBlockTitle), 1),
              _cache[18] || (_cache[18] = _createElementVNode("img", {
                src: _imports_11,
                alt: "",
                style: {"width":"30px","margin-left":"auto","margin-right":"auto","display":"table"}
              }, null, -1)),
              _createVNode(_unref(Carousel), {
                "items-to-show": 1,
                autoplay: 10000,
                "wrap-around": true
              }, {
                addons: _withCtx(() => [
                  _createVNode(_unref(Navigation))
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(clientQuotes).additionalContent.contentItems, (quotes) => {
                    return (_openBlock(), _createBlock(_unref(Slide), { key: quotes }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("div", {
                              class: "text-muted pb-3 pt-4 px-5",
                              innerHTML: quotes.markdownBody.html
                            }, null, 8, _hoisted_38),
                            _createElementVNode("b", _hoisted_39, _toDisplayString(quotes.displayText), 1),
                            _createElementVNode("p", null, [
                              _createElementVNode("i", null, _toDisplayString(quotes.contentBlockSubtitle), 1)
                            ])
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_40, [
      _createElementVNode("div", _hoisted_41, [
        _cache[19] || (_cache[19] = _createElementVNode("hr", { class: "my-5" }, null, -1)),
        _cache[20] || (_cache[20] = _createElementVNode("h2", null, [
          _createElementVNode("small", { class: "text-uppercase d-block" }, "Nologo Studios"),
          _createTextVNode(" Subsidiaries ")
        ], -1)),
        _createElementVNode("div", _hoisted_42, [
          _createVNode(_unref(Carousel), {
            id: "Subsidiaries",
            breakpoints: _unref(breakpointSubsidiary),
            autoplay: 10000,
            "wrap-around": true
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subsidiaries), (subsidiary, index) => {
                return (_openBlock(), _createBlock(_unref(Slide), { key: subsidiary }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "card w-100 overflow-hidden shadow wow animate__fadeInUp",
                      "data-wow-delay": `0.${5+index}s`
                    }, [
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("img", {
                          src: _unref(CmsBaseUrl)() + subsidiary.cardLogo.urls[0],
                          alt: subsidiary.displayText + ' logo'
                        }, null, 8, _hoisted_45),
                        _createElementVNode("div", {
                          class: "text-muted text-start pb-3 pt-4 px-3",
                          innerHTML: subsidiary.blurb.html
                        }, null, 8, _hoisted_46),
                        _createElementVNode("div", _hoisted_47, [
                          _createVNode(_component_router_link, {
                            class: "btn btn-outline-dark text-uppercase rounded-0 py-2 px-4 px-sm-5",
                            to: { name: 'subsidiary', params: { alias: _unref(getSubsidiarySlug)(subsidiary.alias.alias) } }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" View " + _toDisplayString(subsidiary.displayText), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ])
                      ]),
                      _createElementVNode("img", {
                        src: _unref(CmsBaseUrl)() + subsidiary.cardImage.urls[0],
                        class: "w-100",
                        style: {"margin-top":"-60px","pointer-events":"none"},
                        alt: ""
                      }, null, 8, _hoisted_48)
                    ], 8, _hoisted_43)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["breakpoints"])
        ]),
        _cache[21] || (_cache[21] = _createElementVNode("hr", { class: "my-5" }, null, -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_49, [
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("div", _hoisted_51, [
          _createVNode(ContactForm)
        ]),
        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "col-lg-6 order-lg-0 lh-1" }, [
          _createElementVNode("iframe", {
            src: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13844.626601511483!2d30.9518452!3d-29.8308998!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1ef700efd1e6aeff%3A0xa3e544220bd5304b!2sNologo%20Studios!5e0!3m2!1sen!2sza!4v1691150863115!5m2!1sen!2sza",
            width: "100%",
            height: "700",
            style: {"border":"0"},
            allowfullscreen: "",
            loading: "lazy",
            referrerpolicy: "no-referrer-when-downgrade"
          })
        ], -1))
      ])
    ])
  ], 64))
}
}

})